import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpGenericService } from './generic-http.service';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends HttpGenericService {
  constructor(httpClient: HttpClient) {
    super(httpClient, environment.apiUrl, 'Email');
  }
}
